import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

export default function heroComponent(config = {}) {
    const normalizedConfig = typeof config === 'number' ? { totalSlides: config } : (config || {});
    const initialTotalSlides = Number.isFinite(Number(normalizedConfig.totalSlides))
        ? Number(normalizedConfig.totalSlides)
        : 0;
    const initialSlideDelaySeconds = Number.isFinite(Number(normalizedConfig.slideDelay))
        ? Number(normalizedConfig.slideDelay)
        : 3;

    return {
        slideDelaySeconds: initialSlideDelaySeconds,
        totalSlides: initialTotalSlides,
        currentIndex: 0,
        previousIndex: -1,
        animationKey: 0,
        videos: [],
        textLines: [],
        slideIntervalId: null,
        init() {
            const copyItems = this.$refs.heroCopy?.children || [];
            const videoItems = this.$refs.heroVideos?.children || [];

            this.totalSlides = this.totalSlides || copyItems.length || videoItems.length || 0;

            this.currentIndex = 0;
            this.previousIndex = -1;
            this.videos = [];
            this.ensureBackgroundVideoPlayback();
            this.startAutoAdvance();

            this.$nextTick(() => {
                this.captureTextLines();
                this.triggerAnimation(this.currentIndex);
            });
        },
        ensureBackgroundVideoPlayback() {
            const video = this.$refs.backgroundVideo;
            if (!video) {
                return;
            }
            video.play?.().catch?.(() => {});
        },
        startAutoAdvance() {
            this.stopAutoAdvance();
            const delayMs = Math.max(0, Number(this.slideDelaySeconds) || 0) * 1000;
            if (!delayMs || this.totalSlides <= 1) {
                return;
            }

            this.slideIntervalId = globalThis.setInterval(() => {
                this.goToNextSlide();
            }, delayMs);
        },
        stopAutoAdvance() {
            if (!this.slideIntervalId) {
                return;
            }
            globalThis.clearInterval(this.slideIntervalId);
            this.slideIntervalId = null;
        },
        isVisible(index) {
            return index === this.currentIndex;
        },
        shouldAnimateLine(slideIndex, lineIndex) {
            if (slideIndex !== this.currentIndex) {
                return false;
            }
            if (this.previousIndex === -1) {
                return true;
            }
            const prevLines = this.textLines[this.previousIndex] || [];
            const currentLines = this.textLines[this.currentIndex] || [];
            return prevLines[lineIndex] !== currentLines[lineIndex];
        },
        triggerAnimation(slideIndex) {
            if (slideIndex !== this.currentIndex) {
                return;
            }
            const currentItem = this.$refs.heroCopy?.children[this.currentIndex];
            if (!currentItem) {
                return;
            }
            const heading = currentItem.querySelector('h2');
            if (!heading) {
                return;
            }
            const divs = Array.from(heading.children);
            if (!divs.length) {
                return;
            }

            divs.forEach((div, lineIndex) => {
                if (!this.shouldAnimateLine(slideIndex, lineIndex)) {
                    return;
                }

                if (div._gsapSplit) {
                    div._gsapSplit.revert();
                    div._gsapSplit = null;
                }

                div.style.opacity = '0';

                const split = new SplitText(div, { type: 'words,chars' });
                div._gsapSplit = split;

                gsap.set(split.chars, { opacity: 0, y: 10 });
                gsap.to(split.chars, {
                    opacity: 1,
                    y: 0,
                    duration: 0.6,
                    stagger: {
                        amount: 0.5,
                        from: 'start'
                    },
                    delay: lineIndex * 0.1,
                    ease: 'back.out',
                    clearProps: 'none',
                    onStart: () => {
                        div.style.opacity = '1';
                    },
                    onComplete: () => {
                        split.revert();
                        div._gsapSplit = null;
                        div.style.opacity = '';
                    }
                });
            });
        },
        destroy() {
            this.stopAutoAdvance();
            if (this.$refs.heroCopy) {
                gsap.killTweensOf(this.$refs.heroCopy.querySelectorAll('*'));

                Array.from(this.$refs.heroCopy.children).forEach(item => {
                     const heading = item.querySelector('h2');
                     if (heading) {
                         Array.from(heading.children).forEach(div => {
                             if (div._gsapSplit) {
                                 div._gsapSplit.revert();
                                 div._gsapSplit = null;
                             }
                         });
                     }
                });
            }
        },
        captureTextLines() {
            const items = this.$refs.heroCopy?.children || [];
            this.textLines = Array.from(items).map((item) => {
                const heading = item.querySelector('h2');
                if (!heading) return [];
                const divs = heading.children;
                return Array.from(divs).map((div) => div.textContent.trim());
            });
        },
        goToNextSlide() {
            if (!this.totalSlides) {
                return;
            }

            const prevIndex = this.currentIndex;
            const nextIndex = (this.currentIndex + 1) % this.totalSlides;

            this.captureTextLines();
            this.previousIndex = prevIndex;
            this.currentIndex = nextIndex;
            this.animationKey++;

            this.$nextTick(() => {
                this.triggerAnimation(this.currentIndex);
            });
        }
    };
}

